export default __webpack_public_path__ + "static/media/logo.089a48e0.png";